import {Injectable} from "@angular/core";
import {RequestMethod, Response} from "@angular/http";
import {BehaviorSubject, Observable} from "rxjs";
import {RequestConfig, RestResponse} from "../../shared/rest/rest.request";
import {CustomHttp} from "../../common/http/custom.http";
import {PageImpl} from "../../common/http/PageImpl";
import { isNullOrUndefined } from "util";
import { NzI18nService ,es_ES} from "ng-zorro-antd";

@Injectable()
export class GroupsService {
    private GET_ALL_CODE = new RequestConfig("GRU", "application/json", true, RequestMethod.Get, "/groups/all");
    private CREATE_CODE = new RequestConfig("GRU", "application/json", true, RequestMethod.Post, "/groups");
    private EDIT_CODE = new RequestConfig("GRU", "application/json", true, RequestMethod.Put, "/groups/{groupId}");
    private DELETE_CODE = new RequestConfig("GRU", "application/json", true, RequestMethod.Delete, "/groups/{groupId}");
    private GET_CODE = new RequestConfig("GRU", "application/json", true, RequestMethod.Get, "/groups/{groupId}");
    private GET_PAGE = new RequestConfig("GRU", "application/json", true, RequestMethod.Get, "/groups");
    private GET_GROUP_BY_USER = new RequestConfig("GRU", "application/json", true, RequestMethod.Get, "/groups/by-user/{idUserApp}");
    private GET_GROUP_TREE = new RequestConfig('GRU', 'application/json', true, RequestMethod.Get, '/groups/by-user/{idUserApp}/tree');
    private MASIVE_UPDATE = new RequestConfig("GRU", "application/json", true, RequestMethod.Put, "/groups/masivoE2E");
    private UPDATE_MASIVE_INMMEDIATE_SALE = new RequestConfig("GRU", "application/json", true, RequestMethod.Put, "/groups/masivoVentaInmediata");


    constructor(private http: CustomHttp,
        private i18n: NzI18nService) {
            this.i18n.setLocale(es_ES);
    }

    /**
     * Envia una petición a WS para guardar grupo
     */
    saveGroups(groups: Groups): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, groups)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de un grupo
     */
    getGroups(groupId: number): Observable<Groups> {
        return this.http.sendRequest(this.GET_CODE, {}, groupId)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

        /**
     * Envia petición a WS para obtener detalles de un grupo
     */
    getGroupsByUser(idUserApp: number): Observable<Groups> {
        return this.http.sendRequest(this.GET_GROUP_BY_USER, {}, idUserApp)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    /**
     * Envia petición a WS para obtener detalles de los grupos
     */
    getAll(idGroup?:number): Observable<Array<Groups>> {
        if(isNullOrUndefined(idGroup)){
            idGroup = null;
        }
        let groupsAll: any = localStorage.getItem('groupsAll');
        if (groupsAll != undefined || groupsAll != null) {
            let groupsAllParse = JSON.parse(groupsAll)
            if (groupsAllParse != undefined) {
                let newData = new BehaviorSubject<any>(null);
                newData.next(groupsAllParse)
                return newData;
            }
        }
        else {
            return this.http.sendRequest(this.GET_ALL_CODE,{idGroup:idGroup})
                .map((res:any) => {
                    try {
                        localStorage.setItem('groupsAll', res._body);
                        return res.json();
                    } catch (e) {
                        return e => this.http.handleError(e);
                    }
                })
        };
    }


    /**
     * Envia petición a WS para obtener detalles de los grupos
     */
    getAllGroups(idGroups?:number[]): Observable<Array<Groups>> {
        if(idGroups.length == 0){
            idGroups = [];
        }
        return this.http.sendRequest(this.GET_ALL_CODE,{idGroup:idGroups})
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }


    /**
     * Envía petición a WS para editar datos de grupo
     */
    updateGroups(groups: Groups): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, groups, groups.groupId)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de grupo
     */
    deleteGroups(groupId: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, groupId)
            .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<Groups>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    /**
     * Envia petición a WS para obtener detalles de un grupo
     */
    getGroupsTree(idUserApp: number): Observable<any> {
        return this.http.sendRequest(this.GET_GROUP_TREE, {}, idUserApp)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar masivo permiso e2e
     */
     updateMasiveGroups(groups: any): Observable<RestResponse> {
        return this.http.sendRequest(this.MASIVE_UPDATE, {idGrupos: groups})
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }
    
    updateMasiveInmediateSale(groups: any): Observable<RestResponse> {
        return this.http.sendRequest(this.UPDATE_MASIVE_INMMEDIATE_SALE, { idGrupos: groups })
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

}

@Injectable()
export class Groups {
    public groupId: number;
    public groupName: string;
    public createdDate: Date;
    status: boolean;
    idOrganization: string;
    idParent: number;
    extra1?:number;
    extra2?:number;
    extra3?:boolean;
    code?:number;
    zonaHoraria?:string;
    ventaInmediata?:boolean;
    maxAgendasInstalaciones?: number;
    maxAgendasQuejas?: number;
    maxAgendasMigracion?: number;
}

@Injectable()
export class TicketTypeView {
    public idTicketType: number;
    public typeTicket: string;
    public ticketCategoryView: Array<TicketCategoryView> = [];
}

@Injectable()
export class TicketCategoryView {
    public idTicketCategory: number;
    public categoryName: string;
}

@Injectable()
export class GroupsByUser {

    groupId: number;
    groupName: string;
    status: boolean = true;
    createdDate: number;
    idOrganization: number;
    idParent: number;
}

export class GroupAdvanceSearch {
    active: boolean;
    name: string;
    page: number;
    size: number;
    orderColumn: string;
    orderType: string;
}

